import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { IBuildList } from '../shared/buildList';
import { IWorkItem } from '../shared/workItem';

@Injectable()
export class BuildListService {

    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    constructor(private http: HttpClient) { }

    getBuildListById(buildListId: string): Observable<IBuildList> {
      return this.http.get("/api/buildlist/" + buildListId)
        .pipe(
          map((data: IBuildList) => {
            return data;
          }));
    }

    getBuildListItemById(buildListItemId: string): Observable<IWorkItem> {
      return this.http.get("/api/buildlistitem/" + buildListItemId)
        .pipe(
          map((data: IWorkItem) => {
            return data;
          }));
    }

  loadBuildLists(): Observable<IBuildList[]> {
    return this.http.get("/api/buildlist")
      .pipe(
        map((data: IBuildList[]) => {
          return data;
        }));
  }

  createBuildList(buildList: IBuildList) {
    return this.http.post<IBuildList>("/api/buildlist", buildList, this.httpOptions)
      .pipe(
        catchError(this.handleError<IBuildList>("createBuildList", buildList))
      );
  }

  addToBuildList(buildListId: string, buildList: IBuildList) {
    return this.http.put<IBuildList>("/api/buildlist/" + buildListId, buildList, this.httpOptions)
      .pipe(
        catchError(this.handleError<IBuildList>("addToBuildList", buildList))
      );
    }

  refreshState(buildListId: string) {
    return this.http.put<IBuildList>("/api/buildlist/state/" + buildListId, this.httpOptions)
        .pipe(
            catchError(this.handleError<IBuildList>("refreshState"))
        );
    }

    removeWorkItem(buildListItemId: string) {
        return this.http.delete("/api/buildlistitem/" + buildListItemId, this.httpOptions)
        .pipe(
            catchError(this.handleError("removeWorkItem"))
        );
    }

    updateBuildListItem(buildListItemId: string, workItem: IWorkItem) {
      return this.http.put<IWorkItem>("/api/BuildListItem/" + buildListItemId, workItem, this.httpOptions)
        .pipe(
          catchError(this.handleError<IWorkItem>("updateBuildListItem", workItem))
        );
    }

    private handleError<T>(operation = 'operation', result?: T) {
      return (error: any): Observable<T> => {
        console.error(error);
        return of(result as T);
      }
    }
}
